import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from '../../../key-registry'
import { fromConsignmentItemDetailsResponseV3 } from '../models/mapper'
import { ConsignmentItemDetails } from '../models/types'
import { fetchConsignmentItemV3 } from './http'

export async function fetchConsignmentItem(id: number, opts?: { signal?: AbortSignal }): Promise<ConsignmentItemDetails> {
  const response = await fetchConsignmentItemV3(id, opts)
  return fromConsignmentItemDetailsResponseV3(response)
}

export function useFetchConsignmentItem(id: number | null) {
  return useQuery({
    queryKey: QueryKeys.consignmentItem.details(id),
    queryFn: ({ signal }) => fetchConsignmentItem(id as number, { signal }),
    enabled: !!id,
  })
}
